import React, { useState } from "react";
import Reveal from "@/components/seven/Reveal";

const LOGOS = [
  { src: "/clients/logo-1.png", name: "Espaço Ária" },
  { src: "/clients/logo-2.png", name: "Amine Festas" },
  { src: "/clients/logo-3.png", name: "Secretaria de Cultura · GDF" },
  { src: "/clients/logo-4.png", name: "Secretaria de Turismo · GDF" },
  { src: "/clients/logo-5.png", name: "Óticas Fluminense" },
  { src: "/clients/logo-6.png?v=2", name: "Avont's Burger" },
  { src: "/clients/logo-7.png?v=2", name: "Frangos e Assados" },
  { src: "/clients/logo-8.png?v=2", name: "TechLux" },
];

/**
 * Interactive client logos strip with infinite marquee + pause-on-hover.
 */
export const ClientLogos = () => {
  const [paused, setPaused] = useState(false);
  const list = [...LOGOS, ...LOGOS, ...LOGOS];

  return (
    <section
      className="relative py-20 sm:py-28 border-t border-[rgba(245,241,232,0.06)]"
      data-testid="client-logos"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-[#F5F1E8]/55">
            <span className="h-px w-10 bg-[#C5D4B5]/40" />
            <span className="mono text-[10.5px] tracking-[0.24em] uppercase text-[#C5D4B5]">
              Quem confia
            </span>
          </div>
        </Reveal>
        <Reveal delay={80}>
          <h3 className="mt-5 text-[24px] sm:text-[32px] leading-tight tracking-[-0.02em] font-medium text-[#F5F1E8] max-w-2xl">
            Marcas que escolheram crescer com a{" "}
            <span className="text-[#C5D4B5]">Seven Impulse.</span>
          </h3>
        </Reveal>
      </div>

      {/* Marquee */}
      <div
        className="relative mt-10 sm:mt-14 overflow-hidden border-y border-[rgba(197,212,181,0.1)] bg-[rgba(197,212,181,0.02)]"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {/* fade edges */}
        <div
          className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10"
          style={{ background: "linear-gradient(90deg, #0A0A0A, transparent)" }}
        />
        <div
          className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10"
          style={{ background: "linear-gradient(-90deg, #0A0A0A, transparent)" }}
        />

        <div
          className="marquee-track"
          style={{
            animationDuration: "45s",
            animationPlayState: paused ? "paused" : "running",
          }}
        >
          {list.map((l, i) => (
            <div
              key={i}
              className="group relative shrink-0 px-7 sm:px-10 py-6 sm:py-8 flex items-center justify-center transition-all duration-700 hover:bg-[rgba(197,212,181,0.04)]"
              style={{ transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)" }}
              data-cursor="hover"
              title={l.name}
            >
              <img
                src={l.src}
                alt={l.name}
                loading="lazy"
                draggable={false}
                className="h-20 sm:h-28 w-auto max-w-[220px] sm:max-w-[260px] object-contain opacity-90 group-hover:opacity-100 group-hover:scale-[1.08] transition-all duration-700 select-none"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
